
const ShUserMessage = ({
                     error= true, message = "",
                     className = '' }) => {

    if (!message) {
        return null;
    }
    return <p className={ " small-text " + (error ? " text-error " : " text-green ") + className}>
        {message}</p> ;
}

export default ShUserMessage;
